import { render, staticRenderFns } from "./add_insurance.vue?vue&type=template&id=4fbe6234&"
import script from "./add_insurance.vue?vue&type=script&lang=js&"
export * from "./add_insurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports